<template>
    <v-app-bar
     v-if="isNotLogin()"
      app
      color="white"
    >
      <div class="d-flex align-center">
        <v-img
          v-if="!isDemo"
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :style="'cursor: pointer;'"
          @click="goToRoute('Principal')"
          src="../../src/img/eggnovo_logo.png"
          transition="scale-transition"
          width="40"
        />
        <v-img
          v-if="!isDemo"
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          :style="'cursor: pointer;'"
          @click="goToRoute('Principal')"
          min-width="100"
          src="../../src/img/eggnovo_long.png"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-tabs right >
        <v-tab @click="goToRoute('Principal')">ENSAYO</v-tab>
        <v-tab @click="goToRoute('Hornos')">HORNOS</v-tab>
        <v-tab @click="goToRoute('History')">HISTÓRICO</v-tab>
        <v-tab @click="goToRoute('Informes')">INFORMES</v-tab>
        <v-tab @click="goToRoute('HistoricoModificaciones')">MODIFICACIONES</v-tab>
        <v-tab @click="goToRoute('GestionUsuarios')">USUARIOS</v-tab>
        <v-tab @click="goToRoute('HMI')">HMI</v-tab>
        <v-tab @click="goToRoute('Secadero')">SECADERO</v-tab>
        
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-tab v-on="on" @click="goToRoute('Configuracion')">
              <v-icon>mdi-cog</v-icon>
            </v-tab>
          </template>
          <span>Configuración</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-tab v-on="on" @click="cerrarSesion">
              <v-icon>mdi-logout</v-icon>
            </v-tab>
          </template>
          <span>Cerrar Sesión</span>
        </v-tooltip>

      </v-tabs>

    </v-app-bar>
</template>

<script>

export default {
  methods: {
    isNotLogin(){
      return this.$route.name != "Login"
    },
    cerrarSesion(){
      localStorage.removeItem('token')
      this.$router.push({name:'Login'})
    },
    goToRoute(route){
      if(this.$route.name != route)
        this.$router.push({name:route});
    },
    isDemo(){
      return localStorage.getItem('id_rol') == 4
    }
  },
}
</script>